// Bell (goal): a ball (or with any: also a helper) must hit it
import { defineGoal } from '../core/registry';
import { rr, lg, shadowOn, shadowOff, C } from '../core/draw-helpers';
import type { Ctx2D, Gfx, GameBody, GoalState } from '../core/types';

export interface Bell extends GoalState { body: GameBody; hit: boolean; any: boolean }

export function drawBell(ctx: Ctx2D, g: { x: number; y: number; hitT?: number }, t: number, gfx: Gfx) {
  const wd = gfx.worldDef(), own = wd && wd.goal && wd.goal.bell;
  if (own) { own(ctx, g, t, gfx); return; }
  const sw = g.hitT != null ? Math.sin((t - g.hitT) * 0.35) * Math.exp(-(t - g.hitT) * 0.03) * 0.6 : Math.sin(t * 0.03) * 0.04;
  ctx.save(); ctx.translate(g.x, g.y - 44);
  ctx.fillStyle = C.ink; rr(ctx, -30, -10, 60, 8, 4); ctx.fill();
  ctx.rotate(sw);
  ctx.strokeStyle = C.ink; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(0, -4); ctx.lineTo(0, 8); ctx.stroke();
  shadowOn(ctx, 12, 6);
  ctx.beginPath(); ctx.moveTo(-8, 10); ctx.quadraticCurveTo(-26, 16, -30, 58); ctx.lineTo(30, 58); ctx.quadraticCurveTo(26, 16, 8, 10); ctx.closePath();
  ctx.fillStyle = lg(ctx, 10, 58, C.gold1, C.gold2); ctx.fill(); shadowOff(ctx);
  ctx.beginPath(); ctx.ellipse(-10, 30, 4, 12, 0.3, 0, 7); ctx.fillStyle = 'rgba(255,255,255,.6)'; ctx.fill();
  ctx.beginPath(); ctx.arc(0, 62, 7, 0, 7); ctx.fillStyle = '#C97A0A'; ctx.fill();
  ctx.restore();
}

export const bell = defineGoal({
  create(api, g) {
    const b = api.add(api.Bodies.circle(g.x, g.y, 30, { isStatic: true, isSensor: true }));
    b.kind = 'bell';
    const goal: Bell = { type: 'bell', x: g.x, y: g.y, body: b, hit: false, any: !!g.any };
    return goal;
  },
  check(api, goal) {
    const S = api.S;
    S.inGoal = goal.hit ? 1 : 0;
    if (goal.hit && S.t - S.winT > 20) { S.won = true; S.events.push({ e: 'win' }); }
  },
  blockers: g => [{ x: g.x, y: g.y, r: 42 }],
  draw: (ctx, goal, inGoal, t, gfx) => drawBell(ctx, goal, t, gfx),
  // the bell swings and plays notes
  fx: {
    bell(ev, f) {
      f.sfx('bell'); f.S.goal!.hitT = f.t;
      for (let i = 0; i < 6; i++) f.particle({ x: ev.x! + (Math.random() - .5) * 60, y: ev.y! - 40, vx: (Math.random() - .5) * 2, vy: -2 - Math.random() * 2, life: 70, max: 70, col: '#3B2A5C', r: 6, kind: 'note' });
    },
  },
  system: {
    contact: {
      bell(api, x, y) {
        const S = api.S, goal = S.goal as Bell;
        if ((y.kind === 'hero' || (goal.any && y.kind === 'helper')) && !goal.hit) { goal.hit = true; S.winT = S.t; S.events.push({ e: 'bell', x: x.position.x, y: x.position.y }); }
      },
    },
  },
});
